import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "../button";
import { Link } from "react-router-dom";

Category.propTypes = {};

function Category(props) {
  const { data } = props;
  const { className } = props;

  // const [dataBlock] = useState({
  //   title: "Browse by category",
  //   text: "Recruitment Made Easy in 100 seconds",
  // });
  return (
    <section className={className}>
      <div className="container mt-4 candidateHomeCat">
        <div className="row">
          <div className="col-md-12">
            <div className="tf-title">
              <div className="group-title">
                <h1>{props.title}</h1>
                <p>{props.text}</p>
              </div>
              {/* <Button title="All Categories" link="/joblist_v1" /> */}
            </div>
          </div>

          <div className="col-md-12">
            <div
              className="group-category-job  fadeInUp"
              data-wow-delay=".2s"
            >
              {/* {data.map((idx) => ( */}
                <div   className={`job-category-box `}>
                  <div className="job-category-header">
                    <h1>
                      <Link to="/jobDetails">Designation</Link>
                    </h1>
                    <p></p>
                  </div>
                  <Link to="/jobDetails" className="btn-category-job">
                    Explore Jobs{" "}
                    <span className="icon-keyboard_arrow_right"></span>
                  </Link>
                </div>
                <div   className={`job-category-box `}>
                  <div className="job-category-header">
                    <h1>
                      <Link to="/jobDetails">Level:</Link>
                    </h1>
                    <p> Fresher</p>
                  </div>
                  <Link to="/jobDetails" className="btn-category-job">
                    Explore Jobs{" "}
                    <span className="icon-keyboard_arrow_right"></span>
                  </Link>
                </div>
                <div   className={`job-category-box `}>
                  <div className="job-category-header">
                    <h1>
                      <Link to="/jobDetails">Mode:</Link>
                    </h1>
                    <p> Remote, Hybrd, Freelancing</p>
                  </div>
                  <Link to="/jobDetails" className="btn-category-job">
                    Explore Jobs{" "}
                    <span className="icon-keyboard_arrow_right"></span>
                  </Link>
                </div>
                <div   className={`job-category-box `}>
                  <div className="job-category-header">
                    <h1>
                      <Link to="/jobDetails">Industry</Link>
                    </h1>
                    <p></p>
                  </div>
                  <Link to="/jobDetails" className="btn-category-job">
                    Explore Jobs{" "}
                    <span className="icon-keyboard_arrow_right"></span>
                  </Link>
                </div>
                <div   className={`job-category-box `}>
                  <div className="job-category-header">
                    <h1>
                      <Link to="/jobDetails">Company</Link>
                    </h1>
                    <p></p>
                  </div>
                  <Link to="/jobDetails" className="btn-category-job">
                    Explore Jobs{" "}
                    <span className="icon-keyboard_arrow_right"></span>
                  </Link>
                </div>
                <div   className={`job-category-box `}>
                  <div className="job-category-header">
                    <h1>
                      <Link to="/jobDetails">Skill</Link>
                    </h1>
                    <p></p>
                  </div>
                  <Link to="/jobDetails" className="btn-category-job">
                    Explore Jobs{" "}
                    <span className="icon-keyboard_arrow_right"></span>
                  </Link>
                </div>
              {/* ))} */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Category;
